import * as xterm from 'xterm'

// All themes can be found athttp://github.com/mbadolato/iTerm2-Color-Schemes/tree/master/vscode

export const SOLARIZED_DARK: xterm.ITheme = Object.freeze<xterm.ITheme>({
  foreground: '#839496',
  background: '#002b36',
  black: '#073642',
  blue: '#268bd2',
  cyan: '#2aa198',
  green: '#859900',
  magenta: '#d33682',
  red: '#dc322f',
  white: '#eee8d5',
  yellow: '#b58900',
  brightBlack: '#002b36',
  brightBlue: '#839496',
  brightCyan: '#93a1a1',
  brightGreen: '#586e75',
  brightMagenta: '#6c71c4',
  brightRed: '#cb4b16',
  brightWhite: '#fdf6e3',
  brightYellow: '#657b83'
})

export const SOLARIZED_LIGHT: xterm.ITheme = Object.freeze<xterm.ITheme>({
  cursor: '#839496',
  cursorAccent: '#839496',
  foreground: '#657b83',
  background: '#fdf6e3',
  black: '#073642',
  blue: '#268bd2',
  cyan: '#2aa198',
  green: '#859900',
  magenta: '#d33682',
  red: '#dc322f',
  white: '#eee8d5',
  yellow: '#b58900',
  brightBlack: '#002b36',
  brightBlue: '#839496',
  brightCyan: '#93a1a1',
  brightGreen: '#586e75',
  brightMagenta: '#6c71c4',
  brightRed: '#cb4b16',
  brightWhite: '#fdf6e3',
  brightYellow: '#657b83'
})
